var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"board__pending-actions"},[_c('BoardCardColumnTitle',{attrs:{"title":"PENDING","clean":""}}),_c('BoardCardPending')],1)}
var staticRenderFns = []

export { render, staticRenderFns }